import {useGeneral} from '@contexts/GeneralContext.tsx';
import {getByUrl} from '@localization/siteMap/breadcrumbs/_Sitemap.ts';
import {Breadcrumbs, Grid, IconButton, Tooltip, Typography} from '@mui/material';
import React from 'react';
import {Link, useLocation, useNavigate,} from 'react-router-dom';
import {ArrowBack} from '@mui/icons-material'

export const BreadcrumbsMap: React.FC = () => {
    const {screenSizeLevel} = useGeneral();
    const location = useLocation();
    const navigate = useNavigate();

    const previousEntry = window.history.state


    const result = getByUrl(location.pathname);

    return (<Grid>
            <Breadcrumbs sx={{pb: 1.5, px: 2}} separator="›">
                <IconButton disabled={previousEntry == null || previousEntry.idx == 0} onClick={() => navigate(-1)}>
                    <ArrowBack/>
                </IconButton>
                {result && result.path.map((item) => (
                    <Tooltip title={item.descricao} enterDelay={750}>
                        {item.fullUrl == location.pathname ? <Typography
                                fontSize={screenSizeLevel > 6 ? 'small' : screenSizeLevel == 6 ? 'medium' : 'large'}
                                key={item.fullUrl}>
                                {item.nome}
                            </Typography> :
                            <Typography
                                key={item.fullUrl}
                                fontSize={screenSizeLevel > 6 ? 'small' : screenSizeLevel == 6 ? 'medium' : 'large'}
                                component={Link}
                                color={'textPrimary'}
                                to={item.fullUrl}>
                                {item.nome}
                            </Typography>}
                    </Tooltip>
                ))}
            </Breadcrumbs>
        </Grid>
    );
};
